module.exports = "<div class=\"map-wrapper\" role=\"application\">\n  <div id=\"map\" #map class=\"map\">\n\n  </div>\n</div>\n"